// router/index.js
import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import { useAppStore } from '@/stores'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录', requiresAuth: false },
  },
  {
    path: '/',
    redirect: '/production',
  },
  {
    path: '/production',
    name: 'ProductionView',
    component: () => import('@/views/ProductionView.vue'),
    meta: { title: '生产管理', keepAlive: true, requiresAuth: true },
  },
  {
    path: '/production/analysis',
    name: 'ProductionAnalysisView',
    component: () => import('@/views/ProductionAnalysisView.vue'),
    meta: { title: '生产数据分析', keepAlive: false, requiresAuth: true },
  },
  {
    path: '/sale',
    name: 'SaleView',
    component: () => import('@/views/SaleView.vue'),
    meta: { title: '销售管理', keepAlive: true, requiresAuth: true },
  },
  {
    path: '/bookkeeping',
    name: 'BookkeepingView',
    component: () => import('@/views/BookkeepingView.vue'),
    meta: { title: '记账管理', keepAlive: true, requiresAuth: true },
  },
  {
    path: '/styles',
    name: 'StyleView',
    component: () => import('@/views/StyleView.vue'),
    meta: { title: '款式管理', keepAlive: true, requiresAuth: true },
  },
  {
    path: '/materials',
    name: 'MaterialView',
    component: () => import('@/views/MaterialView.vue'),
    meta: { title: '原料管理', keepAlive: true, requiresAuth: true },
  },
  {
    path: '/processes',
    name: 'ProcessView',
    component: () => import('@/views/ProcessView.vue'),
    meta: { title: '加工工艺', keepAlive: true, requiresAuth: true },
  },
  {
    path: '/customer',
    name: 'CustomerView',
    component: () => import('@/views/CustomerView.vue'),
    meta: { title: '客户管理', keepAlive: true, requiresAuth: true },
  },
  {
    path: '/membership/renew',
    name: 'MembershipRenew',
    component: () => import('@/views/membership/RenewView.vue'),
    meta: { title: '会员续费', requiresAuth: true },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/production',
  },
]

// ✅ APK 用 Hash 模式，Web 部署继续用 History 模式
const history = import.meta.env.VITE_APP_TARGET === 'apk'
  ? createWebHashHistory()
  : createWebHistory()

const router = createRouter({
  history,
  routes,
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const appStore = useAppStore()

  // ===== 访问 /login =====
  if (to.path === '/login') {
    if (appStore.isLoggedIn) {
      // 已登录还访问 /login：优先跳 redirect，其次 /production
      const redirect = to.query.redirect || '/production'
      next(redirect)
    } else {
      next()
    }
    return
  }

  // ===== 需要登录的页面 =====
  if (to.meta.requiresAuth !== false) {
    if (!appStore.isLoggedIn) {
      // ✅ 未登录：带上 redirect，登录后跳回原目标
      next({ path: '/login', query: { redirect: to.fullPath } })
      return
    }
  }

  // ===== 设置当前模式 =====
  const modeMap = {
    '/sale': 'sale',
    '/production': 'production',
    '/bookkeeping': 'bookkeeping',
    '/styles': 'styles',
    '/materials': 'materials',
    '/processes': 'processes',
    '/customer': 'customer',
    '/membership/renew': 'membership',
  }
  const mode = modeMap[to.path] || 'sale'
  appStore.setMode(mode)

  next()
})

export default router